// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-footer {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  padding: 8px 16px;
  position: relative;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: height, width, transform, max-width, left, right, top, bottom;
}
:where(.vuetify-styles) .v-footer {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-footer--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-footer {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-footer--absolute {
  position: absolute;
}
:where(.vuetify-styles) .v-footer--fixed {
  position: fixed;
}
:where(.vuetify-styles) .v-footer {
  border-radius: 0;
}
:where(.vuetify-styles) .v-footer {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-footer--rounded {
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VFooter/VFooter.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;EAC7C,kFAAkF;AACpF;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sOAAsO;AACxO;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".v-footer {\n  align-items: center;\n  display: flex;\n  flex: 1 1 auto;\n  padding: 8px 16px;\n  position: relative;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition-property: height, width, transform, max-width, left, right, top, bottom;\n}\n.v-footer {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-footer--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-footer {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-footer--absolute {\n  position: absolute;\n}\n.v-footer--fixed {\n  position: fixed;\n}\n.v-footer {\n  border-radius: 0;\n}\n.v-footer {\n  background: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-footer--rounded {\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
